// import {
//     setIsLoggedIn,
//     setPassphrase,
//     setPrivateKey,
//     setToken,
//     setUserEmail,
//     cleanState,
//     setCacheMailData,
//     setRenderedMailData,
//     setMailSortingOrder,
//     setMailSortingKey,
//     setSearchPlainText,
//     setSearchEncryptedWords,
//     setSearchCurrentPage,
//     setIsSearchRecordsRender,
//     setDomainSortingOrder,
//     setDomainSortingKey,
//     setAliasSortingOrder,
//     setAliasSortingKey,
//     setUser,
//     setIsCacheComplete,
//     setIsCacheDbSetupComplete,
//     setIdbVersion,
//     createStoreWithUser
// } from './store';
//
// class StateManager {
//     static store = null;
//     static persistor = null;
//     static activeUserKey = null;
//
//     static initiateState(userEmail) {
//         const key = `user_state_${userEmail}`;
//
//         if (StateManager.activeUserKey === key) {
//             return;
//         }
//
//         const { store, persistor } = createStoreWithUser(userEmail);
//         StateManager.store = store;
//         StateManager.persistor = persistor;
//         StateManager.activeUserKey = key;
//     }
//
//
//     static getStore() {
//         if (!StateManager.store) {
//             throw new Error("StateManager has not been initialized. Call initiateState(email) first.");
//         }
//         return StateManager.store;
//     }
//
//     static getPersistor() {
//         return StateManager.persistor;
//     }
//
//     static getState() {
//         return StateManager.getStore().getState();
//     }
//
//     // --- Getters ---
//     static getUserEmail() {
//         return this.getState().userEmail;
//     }
//
//     static getPrivateKey() {
//         return this.getState().privateKey;
//     }
//
//     static getPassphrase() {
//         return this.getState().passphrase;
//     }
//
//     static getToken() {
//         return this.getState().token;
//     }
//
//     static isLoggedIn() {
//         return this.getState().isLoggedIn;
//     }
//
//     static cacheMailData() {
//         return this.getState().cacheMailData;
//     }
//
//     static renderedMailData() {
//         return this.getState().renderedMailData;
//     }
//
//     static isCacheComplete() {
//         return this.getState().isCacheComplete;
//     }
//
//     static isCacheDbSetupComplete() {
//         return this.getState().isCacheDbSetupComplete;
//     }
//
//     static getMailSortingOrder() {
//         return this.getState().mailSortingOrder;
//     }
//
//     static getMailSortingKey() {
//         return this.getState().mailSortingKey;
//     }
//
//     static getDomainSortingOrder() {
//         return this.getState().domainSortingOrder;
//     }
//
//     static getDomainSortingKey() {
//         return this.getState().domainSortingKey;
//     }
//
//     static getAliasSortingOrder() {
//         return this.getState().aliasSortingOrder;
//     }
//
//     static getAliasSortingKey() {
//         return this.getState().aliasSortingKey;
//     }
//
//     static getSearchPlainText() {
//         return this.getState().searchPlainText;
//     }
//
//     static getSearchEncryptedWords() {
//         return this.getState().searchEncryptedWords;
//     }
//
//     static getSearchCurrentPage() {
//         return this.getState().searchCurrentPage;
//     }
//
//     static getIsSearchRecordRender() {
//         return this.getState().isSearchRecordsRender;
//     }
//
//     static getIdbVersion() {
//         return this.getState().idbVersion;
//     }
//
//     static getUser() {
//         return this.getState().user;
//     }
//
//     // --- Setters ---
//     static setIdbVersion(version) {
//         return this.getStore().dispatch(setIdbVersion(version));
//     }
//
//     static setIsCacheComplete(value) {
//         return this.getStore().dispatch(setIsCacheComplete(value));
//     }
//
//     static setIsCacheDbSetupComplete(value) {
//         return this.getStore().dispatch(setIsCacheDbSetupComplete(value));
//     }
//
//     static setSearchPlainTextInState(value) {
//         return this.getStore().dispatch(setSearchPlainText(value));
//     }
//
//     static setSearchEncryptedWordsInState(value) {
//         return this.getStore().dispatch(setSearchEncryptedWords(value));
//     }
//
//     static setSearchCurrentPageInState(value) {
//         return this.getStore().dispatch(setSearchCurrentPage(value));
//     }
//
//     static setIsSearchRecordRenderInState(value) {
//         return this.getStore().dispatch(setIsSearchRecordsRender(value));
//     }
//
//     static setMailSortingOrder(order) {
//         this.getStore().dispatch(setMailSortingOrder(order));
//     }
//
//     static setMailSortingKey(key) {
//         this.getStore().dispatch(setMailSortingKey(key));
//     }
//
//     static setDomainSortingOrder(order) {
//         this.getStore().dispatch(setDomainSortingOrder(order));
//     }
//
//     static setDomainSortingKey(key) {
//         this.getStore().dispatch(setDomainSortingKey(key));
//     }
//
//     static setAliasSortingOrder(order) {
//         this.getStore().dispatch(setAliasSortingOrder(order));
//     }
//
//     static setAliasSortingKey(key) {
//         this.getStore().dispatch(setAliasSortingKey(key));
//     }
//
//     static setUserEmail(userEmail) {
//         this.getStore().dispatch(setUserEmail(userEmail));
//     }
//
//     static setPrivateKey(privateKey) {
//         this.getStore().dispatch(setPrivateKey(privateKey));
//     }
//
//     static setPassphrase(passphrase) {
//         this.getStore().dispatch(setPassphrase(passphrase));
//     }
//
//     static setToken(token) {
//         this.getStore().dispatch(setToken(token));
//     }
//
//     static setIsLoggedIn(isLoggedIn) {
//         this.getStore().dispatch(setIsLoggedIn(isLoggedIn));
//     }
//
//     static setCacheMailData(data) {
//         this.getStore().dispatch(setCacheMailData(data));
//     }
//
//     static setRenderedMailData(data) {
//         this.getStore().dispatch(setRenderedMailData(data));
//     }
//
//     static setUser(user) {
//         this.getStore().dispatch(setUser(user));
//     }
//
//     static cleanState() {
//         this.getStore().dispatch(cleanState());
//     }
//
//     static purgePersistedState() {
//         return this.getPersistor()?.purge();
//     }
// }
//
// export default StateManager;

import _ from "lodash"


class StateManager {

    static getUserEmail() {
        return localStorage.getItem("currentUser") || null;
    }

    static setUserEmail(email) {
        localStorage.setItem("currentUser", email);
    }

    static getState() {
        let userEmail = this.getUserEmail()
        if (_.isEmpty(userEmail)) {
            return {}
        }
        const data = localStorage.getItem(userEmail);
        if (_.isEmpty(data)) {
            return {}
        }
        return JSON.parse(data)
    }

    static initiateState(email) {
        let existing = localStorage.getItem(email)
        if (_.isEmpty(existing)) {
            localStorage.setItem(email, JSON.stringify({}))
        }
    }

    static setState(state) {
        let userEmail = this.getUserEmail()
        if (!_.isEmpty(userEmail)) {
            localStorage.setItem(userEmail, JSON.stringify(state))
        }
    }


    static setField(key, value) {
        let state = this.getState()
        state[key] = value
        this.setState(state)
    }

    static cleanState() {
        this.setIsLoggedIn(false)
        this.setPrivateKey(null)
        this.setPassphrase(null)
        this.setToken(null)
        this.setUserEmail(null)
    }

    static getField(key) {
        let state = this.getState()
        if (!_.isEmpty(state)) {
            return state[key]
        } else {
            return null
        }
    }

    static getCurrentMbox() {
        return this.getField("currentMbox") || "INBOX"
    }

    static setCurrentMbox(currentMbox) {
        this.setField("currentMbox", currentMbox)
    }

    static getPrivateKey() {
        return this.getField("privateKey") || null;
    }

    static getPassphrase() {
        return this.getField("passphrase") || null;
    }

    static getToken() {
        return this.getField("token") || null;
    }

    static isLoggedIn() {
        return this.getField("isLoggedIn") || false;
    }

    static renderedMailData() {
        return this.getField("renderedMailData") || {};
    }

    static isCacheComplete() {
        return this.getField("isCacheComplete") || false;
    }

    static isCacheDbSetupComplete() {
        return this.getField("isCacheDbSetupComplete") || false;
    }

    static getMailSortingOrder() {
        return this.getField("mailSortingOrder") || "descending";
    }

    static getMailListingAccount() {
        return this.getField("mailListingAccount") || "all";
    }

    static setMailListingAccount(value) {
        this.setField("mailListingAccount", value)
    }

    static getMailSortingKey() {
        return this.getField("mailSortingKey") || "date";
    }

    static getDomainSortingOrder() {
        return this.getField("domainSortingOrder") || "descending";
    }

    static getDomainSortingKey() {
        return this.getField("domainSortingKey") || "date";
    }

    static getBoxesSortingOrder() {
        return this.getField("domainSortingOrder") || "descending";
    }

    static getBoxesSortingKey() {
        return this.getField("domainSortingKey") || "date";
    }

    static getAliasSortingOrder() {
        return this.getField("aliasSortingOrder") || "descending";
    }

    static getAliasSortingKey() {
        return this.getField("aliasSortingKey") || "date";
    }

    static getSearchPlainText() {
        return this.getField("searchPlainText") || null;
    }

    static getSearchEncryptedWords() {
        return this.getField("searchEncryptedWords") || null;
    }

    static getSearchCurrentPage() {
        return this.getField("searchCurrentPage") || 1;
    }

    static getIsSearchRecordRender() {
        return this.getField("isSearchRecordsRender") || false;
    }

    static getIdbVersion() {
        return this.getField("idbVersion") || 1;
    }

    static setPrivateKey(v) {
        this.setField("privateKey", v);
    }

    static setPassphrase(v) {
        this.setField("passphrase", v);
    }

    static setToken(v) {
        this.setField("token", v);
    }

    static setIsLoggedIn(v) {
        this.setField("isLoggedIn", v);
    }

    static setRenderedMailData(v) {
        this.setField("renderedMailData", v);
    }

    static setIsCacheComplete(v) {
        this.setField("isCacheComplete", v);
    }

    static setIsCacheDbSetupComplete(v) {
        this.setField("isCacheDbSetupComplete", v);
    }

    static setMailSortingOrder(v) {
        this.setField("mailSortingOrder", v);
    }

    static setMailSortingKey(v) {
        this.setField("mailSortingKey", v);
    }

    static setDomainSortingOrder(v) {
        this.setField("domainSortingOrder", v);
    }

    static setDomainSortingKey(v) {
        this.setField("domainSortingKey", v);
    }

    static setBoxesSortingOrder(v) {
        this.setField("boxesSortingOrder", v);
    }

    static setBoxesSortingKey(v) {
        this.setField("boxesSortingKey", v);
    }

    static setAliasSortingOrder(v) {
        this.setField("aliasSortingOrder", v);
    }

    static setAliasSortingKey(v) {
        this.setField("aliasSortingKey", v);
    }

    static setSearchPlainTextInState(v) {
        this.setField("searchPlainText", v);
    }

    static setSearchEncryptedWordsInState(v) {
        this.setField("searchEncryptedWords", v);
    }

    static setSearchCurrentPageInState(v) {
        this.setField("searchCurrentPage", v);
    }

    static setIsSearchRecordRenderInState(v) {
        this.setField("isSearchRecordsRender", v);
    }

    static setIdbVersion(v) {
        this.setField("idbVersion", v);
    }
}


export default StateManager;